<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepTitle$ | async"
  [formGroup]="formStep"
  >
  @if (showStep || stepHasBeenShown) {
    @switch (signatureType$ | async) {
      @case (SignatureTypeEnum.Drawn) {
        <app-draw-initials-step
          [user]="user"
          (stepComplete)="goToNextStep()"
          (previousStepClicked)="goToPreviousStep()"
        ></app-draw-initials-step>
      }
      @default {
        <app-select-initials
          [user]="user"
          (stepComplete)="goToNextStep()"
          (previousStepClicked)="goToPreviousStep()"
        ></app-select-initials>
      }
    }
  }
</app-wizard-step-wrapper>
